var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-wrapper",on:{"click":function($event){return _vm.$bvModal.show('help-modal')}}},[_c('div',{staticClass:"help-button"},[_c('Icon',{attrs:{"tooltip":"Ajuda"}},[_c('HelpCircle')],1)],1),_c('HelpModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }